var map = {
	"./CRM.svg": "./assets/images/support-business/CRM.svg",
	"./Kovo.svg": "./assets/images/support-business/Kovo.svg",
	"./San_Pham.svg": "./assets/images/support-business/San_Pham.svg",
	"./Sapo.svg": "./assets/images/support-business/Sapo.svg",
	"./Tri_Tue.svg": "./assets/images/support-business/Tri_Tue.svg",
	"./Ung_Dung.svg": "./assets/images/support-business/Ung_Dung.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/support-business recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./assets/images/support-business ^\.\/.*$
// module id = ./assets/images/support-business recursive ^\.\/.*$
// module chunks = 0